import { FRAMEWORK_METADATA } from "@/lib/constants/frameworks.metadata";

const DEFAULT_BADGE_CLASS =
  "bg-transparent text-slate-500 dark:text-slate-300 border-slate-300";

export const getFrameworkColor = (framework) =>
  FRAMEWORK_METADATA[framework]?.badgeClass ?? DEFAULT_BADGE_CLASS;

// Custom framework codes are generated server-side as "CF-" + 8 uppercase hex
// chars and validated there against CUSTOM_FRAMEWORK_CODE_RE
// (nxstart-api constants/frameworks.constants.js) — keep this in sync with it.
const CUSTOM_FRAMEWORK_CODE_RE = /^CF-[0-9A-F]{8}$/;
export const isCustomFrameworkCode = (framework) =>
  typeof framework === "string" && CUSTOM_FRAMEWORK_CODE_RE.test(framework);

// Canonical implementation lives in @/helpers/labelUtils (single source of
// truth — the local copies had already drifted). Re-exported to keep existing
// feature imports working.
export { TopicLabel } from "@/helpers/labelUtils";
